import { render, staticRenderFns } from "./itemPriceAnalysis.vue?vue&type=template&id=5e3a2aaf"
import script from "./itemPriceAnalysis.vue?vue&type=script&lang=js"
export * from "./itemPriceAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports